import { Checkbox, CheckboxProps } from "@mui/material";
import CheckBoxCheckedIcon from "library/icon-library/icons/checkBoxCheckedIcon";
import CheckBoxUncheckedIcon from "library/icon-library/icons/checkBoxUncheckedIcon";
import { MouseEventHandler } from "react";

interface CustomCheckboxProps extends Omit<CheckboxProps, "size"> {
  size?: "sm" | "md" | "lg" | "xl";
  isResponsive?: boolean;
}

export const CheckBox = ({
  size = "md",
  isResponsive,
  onClick,
  sx,
  ...rest
}: CustomCheckboxProps) => {
  const checkboxSize = defaultSizes[size] ?? defaultSizes.md;

  return (
    <Checkbox
      onClick={(e) => {
        e.stopPropagation();
        onClick?.(e);
      }}
      icon={<CheckBoxUncheckedIcon />}
      checkedIcon={<CheckBoxCheckedIcon />}
      disableRipple
      sx={{
        height: isResponsive
          ? {
              xs: defaultSizes.sm,
              sm: defaultSizes.sm,
              md: defaultSizes.md,
              lg: defaultSizes.lg,
              xl: defaultSizes.xl,
            }
          : checkboxSize,
        width: isResponsive
          ? {
              xs: defaultSizes.sm,
              sm: defaultSizes.sm,
              md: defaultSizes.md,
              lg: defaultSizes.lg,
              xl: defaultSizes.xl,
            }
          : checkboxSize,
        padding: "3px",
        ...sx,
      }}
      {...rest}
    />
  );
};
const defaultSizes = {
  sm: "20px",
  md: "24px",
  lg: "28px",
  xl: "32px",
};
